//----------------------------------------------------
// src/pages/NoAccess.jsx — Toegangsweigering
//----------------------------------------------------
import React from "react";

export default function NoAccess({
  allowedRoles = [],
  requiredRoles = [],
  currentRole,
  userRole,
}) {
  const rolesToShow = Array.isArray(allowedRoles) && allowedRoles.length > 0
    ? allowedRoles
    : requiredRoles;
  const visibleRole = currentRole || userRole || "";

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
      <div className="bg-white shadow-lg rounded-2xl p-8 max-w-md w-full border border-red-300">
        <h1 className="text-2xl font-bold text-red-700 mb-4">
          🚫 Geen toegang
        </h1>
        <p className="mb-2 text-gray-700">
          Je hebt geen toegang tot deze pagina op basis van je rol.
        </p>

        <p className="mt-4 text-sm text-gray-600">
          Vereiste rol(len):
        </p>
        <ul className="list-disc list-inside text-sm text-gray-800 mb-4">
          {rolesToShow.map((r) => (
            <li key={r}>{r}</li>
          ))}
        </ul>

        <p className="text-sm text-gray-600">
          Jouw huidige rol:{" "}
          <span className="font-semibold text-gray-900">
            {visibleRole || "Onbekend"}
          </span>
        </p>
      </div>
    </div>
  );
}
